import updateCookieConsent from './updateCookieConsent'

export default updateCookieConsent

export { default as triggerGetUpdatedCookieWhitelistByTermly } from './triggerGetUpdatedCookieWhitelistByTermly'
